import { PageBase } from "components/page/user/contractFrk/edit/parts/pageBase";
import React from "react";
import { withRouter } from "react-router";
import PopupOrganizationList from "../../popup/popupOrgList";
import PopupTmpleteList from "../../popup/popupTmpleteList";
import Block1 from "./block1";
import Block10 from "./block10";
import Block5 from "./block5";
import Block6 from "./block6";
import Block7 from "./block7";
import Block8 from "./block8";
import Block9 from "./block9";

class BasPage1 extends PageBase {
    constructor(props) {
        super(props);

        // データ取得時点で値が空になっている項目はundefinedにする
        this.state = {
            ...this.state,
            ...this.getPageItems(),
        };
        this.setup();
    }

    /**
     * ページで使用する項目を定義する
     * ※データ取得時点で値が空になっている項目はundefinedにする
     */
    getPageItems = () => {
        return {
            // ここから契約情報の項目値
            // 物件名と稟議書No.
            TOR00303: undefined, // 物件名　都道府県
            TOR00304: undefined, // 物件名　市区町村
            TOR00305: undefined, // 物件名　丁目
            TOR00200: undefined, // 物件名
            TOR00201: undefined, // 稟議書No.

            // 区分所有建物
            // 一棟の建物の表示
            TOR00205: undefined, // 建物の名称
            TOR00300: undefined, // 建物の名称　棟
            TOR00301: undefined, // 建物の名称　階
            TOR00302: undefined, // 建物の名称　号室
            TOR00356: undefined, // 建物の名称　フリー
            TOR00206: undefined, // 住居表示
            TOR00207: undefined, // 所在
            TOR00208: undefined, // 構造
            TOR00209: undefined, // 延床面積
            // 専有部分の建物の表示
            TOR00210: undefined, // 家屋番号
            TOR00211: undefined, // 建物の名称
            TOR00212: undefined, // 種類
            TOR00213: undefined, // 構造
            TOR00214: undefined, // 床面積　階部分
            TOR00215: undefined, // 床面積　登記簿
            TOR00216: undefined, // 床面積　壁芯
            TOR00306: undefined, // 区分所有建物　建築時期　元号
            TOR00307: undefined, // 区分所有建物　建築時期　年
            TOR00308: undefined, // 区分所有建物　建築時期　月
            TOR00309: undefined, // 区分所有建物　建築時期　新築
            TOR00310: undefined, // 区分所有建物　建築時期　フリー
            TOR00311: false, // 区分所有建物　付属建物　有
            TOR00312: false, // 区分所有建物　付属建物　無
            TOR00314: undefined, // 区分所有建物　付属建物　フリー

            // 敷地権の目的たる土地
            TOR00217_ARR: [{
                TOR00217: undefined, // 所在および地番
                TOR00218: undefined, // 地目
                TOR00219: undefined, // 地積　公簿
                TOR00221: undefined, // 敷地権の種類
                TOR00315: undefined, // 敷地権の割合
            },],
            TOR00235: undefined, // 合筆数
            TOR00236: undefined, // 登記簿合計面積

            // 土地
            TOR00237_ARR: [{
                TOR00237: undefined, // 所在
                TOR00238: undefined, // 地番
                TOR00239: undefined, // 他筆
                TOR00240: undefined, // 地目
                TOR00241: undefined, // 地積　公簿
                TOR00243: undefined, // 持分
            },],
            TOR00256: undefined, // 合筆数
            TOR00257: undefined, // 登記簿合計面積

            // 建物
            TOR00258: undefined, // 住居表示
            TOR00259: undefined, // 所在
            TOR00260: undefined, // 家屋番号
            TOR00261: undefined, // 種類
            TOR00262: undefined, // 構造
            TOR00355: true, // 床面積　斜線
            TOR00316: false, // 登記簿　チェック
            TOR00317: undefined, // １階（㎡）
            TOR00318: undefined, // ２階（㎡）
            TOR00319: undefined, // 床面積　フリー
            TOR00320: false, // 現況　チェック
            TOR00321: undefined, // その他
            TOR00322: undefined, // 合計（㎡）
            TOR00323: undefined, // 建物　建築時期　元号
            TOR00324: undefined, // 建物　建築時期　年
            TOR00325: undefined, // 建物　建築時期　月
            TOR00326: undefined, // 建物　建築時期　新築
            TOR00327: false, // 増築　チェック
            TOR00328: false, // 改築　チェック
            TOR00329: undefined, // 建物　増築・改築　元号
            TOR00330: undefined, // 建物　増築・改築　年
            TOR00331: undefined, // 建物　増築・改築　月


            // 売主様
            TOR00072_ARR: [{
                TOR00072: undefined, // 売主 氏名
                TOR00332: undefined, // 売主　敬称
            },],
            TOR00349: undefined, // 売主　重要事項説明書　署名欄
            TOR00350: false, // 売主　売買契約書　修正
            TOR00351: undefined, // 売主　売買契約書　署名欄

            // 買主様
            TOR00094_ARR: [{
                TOR00094: undefined, // 買主 氏名
                TOR00334: undefined, // 買主　敬称
            },],
            TOR00352: undefined, // 買主　重要事項説明書　署名欄
            TOR00353: false, // 買主　売買契約書　修正
            TOR00354: undefined, // 買主　売買契約書　署名欄

        };
    }

    /** 動的に項目数が変動する項目のキー名を設定する ※参照のみの場合は不要 */
    getDynamicItemKeys = () => {
        return ["TOR00072_ARR", "TOR00094_ARR", "TOR00217_ARR", "TOR00237_ARR"];
    }

    /** 参照しか行われない項目のキー名を設定する */
    getRefOnlyItemKeys = () => {
        return [];
    }

    /**
     *  郵便番号の3桁、4桁が別々の入力欄になっているので、
     * 項目名を指定して、7桁の文字列に変換する
     **/
    combineZip = (zip3Key, zip4Key) => {
        // 郵便番号入力部分の3桁と4桁の入力欄を合わせて1つにする

        // 入力がない場合、undefined（リクエストに含めないようにするため）
        if (this.state[zip3Key] === undefined && this.state[zip4Key] === undefined) {
            return undefined;
        }

        // 入力したけど消した場合、""（空文字列で規定値を上書きするため）
        if (this.state[zip3Key] === undefined && this.state[zip4Key] === "") {
            return "";
        }
        if (this.state[zip3Key] === "" && this.state[zip4Key] === undefined) {
            return "";
        }
        if (this.state[zip3Key] === "" && this.state[zip4Key] === "") {
            return "";
        }

        // 入力があった場合
        const zip3 = this.state[zip3Key] === undefined ? "" : this.state[zip3Key];
        const zip4 = this.state[zip4Key] === undefined ? "" : this.state[zip4Key];
        return zip3 + "-" + zip4;
    }

    /** this.stateの中から契約情報項目のみを抽出する */
    pickupContractInfo = () => {
        let tmp = {};
        this.contractInfoKeys.forEach(val => {
            tmp[val] = this.state[val];
        });

        // 郵便番号入力部分の3桁と4桁の入力欄を合わせて1つにする
        // 売主様 > 住所 > 郵便番号
        tmp["TOR00074"] = this.combineZip("TOR00074_1", "TOR00074_2");
        delete tmp["TOR00074_1"];
        delete tmp["TOR00074_2"];

        // 郵便番号入力部分の3桁と4桁の入力欄を合わせて1つにする
        // 買主様 > 住所 > 郵便番号
        tmp["TOR00096"] = this.combineZip("TOR00096_1", "TOR00096_2");
        delete tmp["TOR00096_1"];
        delete tmp["TOR00096_2"];

        // オブジェクトの値が全て空の場合、false
        const hasObjectValue = (obj) => {
            for (const item in obj) {
                const tmp = obj[item];
                if (!(tmp === undefined || tmp === null || tmp === "")) {
                    return true;
                }
            }
            return false;
        };

        // 動的に数が変動する項目に関して値が入っていない場合、項目値をundefinedにする
        // ※Amplifyの仕様でundefinedになっている項目はAPIリクエストパラメータから除外されるため
        this.arrayKeys.forEach(name => {
            let _ = []; // 値が入っているオブジェクトを暫定で格納するための配列

            // 動的項目の中身をチェックして、オブジェクトの値が全て空の場合、該当のオブジェクトを除外する
            // ※リクエストの対象から外すため
            const arrayItem = tmp[name];
            arrayItem.forEach(obj => {

                // オブジェクトがキーを持っている場合 かつ
                // オブジェクトのキー値が空でない場合
                if (Object.keys(obj).length !== 0 && hasObjectValue(obj)) {
                    _.push(obj);
                }
            });

            // 全ての動的項目の値が空だった場合、undefinedにする
            tmp[name] = _.length !== 0 ? _ : undefined;
        });
        return tmp;
    }

    /** 初回表示時の初期情報取得 */
    componentDidMount = () => {
        this.init();
    }

    componentDidUpdate = () => {

        // リロード用 ※リロードが必要な場合、setState({init: false})する
        if (this.state.init === false) {
            this.init();
        }
    }

    render() {
        // データ取得されるまでは空を表示する
        // ※APIリクエストの正常時コールバック内でsetState({init: true})を行い、APIレスポンスの内容を使って再レンダリングさせる
        if (this.state.init === false) {
            return null;
        }

        // レンダリングのタイミングでページが持っている契約情報を大元に同期する
        this.props.sync(this.pickupContractInfo());

        const params = {
            pageState: this.state,
            updatePageState: this.updatePageState,
            contractTypeId: this.props.contractTypeId,  // 契約種別ID
            contractType: this.props.contractType,
            selectboxData: this.props.selectboxData,
        };

        // 敷地権の目的たる土地 または 土地の表示／非表示設定
        let blockItem = (<li><Block7 {...params} /></li>); // 土地

        if (this.props.contractType.indexOf("（敷地権）") !== -1 || this.props.contractType.indexOf("定期借地権付区分所有建物") !== -1) {
            blockItem = (<li><Block6 {...params} /></li>); // 敷地権の目的たる土地
        }

        return (
            <React.Fragment>
                <ul className="l-dataList">
                    <li><Block1 {...params} /></li> {/** 物件名と稟議書No. */}
                    <li><Block5 {...params} /></li> {/** 区分所有建物 */}
                    {blockItem} {/** 敷地権の目的たる土地 or 土地 */}
                    <li><Block8 {...params} /></li> {/** 建物 */}
                    <li><Block9 {...params} /></li> {/** 売主様 */}
                    <li><Block10 {...params} /></li> {/** 買主様 */}
                </ul>
                <PopupTmpleteList {...params} to={this.state.popupTarget} from={this.state.popupFrom} popupFlagName="dispPopupTmpl" />
                <PopupOrganizationList {...params} to={this.state.popupTarget} from={this.state.popupFrom} popupFlagName="dispPopupOrg" />
            </React.Fragment>
        );
    }
}

export default withRouter(BasPage1);